
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Learn about resetting passwords, account management, two-factor authentication, and key rotations to protect your developer account and keep your keys safe.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Plaid Dashboard account security and account management' subtitle='Learn how to protect and manage your Plaid Dashboard account' mdxType="Header" />
    <h4 {...{
      "id": "password-resets"
    }}>{`Password resets`}</h4>
    <p>{`To reset your password, log in to the Plaid Dashboard, then access the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/personal/security"
      }}>{`Personal Security page`}</a>{`, which contains a password reset screen.`}</p>
    <p>{`If you ever forget your password to your Plaid Dashboard account, use the `}<strong parentName="p">{`Forgot password?`}</strong>{` link on the login page to reset your password. You will only be able to receive your password reset email if you have verified your Plaid email address. If your email address is unverified, search your email for a message from `}<a parentName="p" {...{
        "href": "mailto:no-reply@plaid.com"
      }}>{`no-reply@plaid.com`}</a>{` with the subject line "Confirm your email" and click on the link in that email to verify your address. You should then be able to reset your password.`}</p>
    <h4 {...{
      "id": "two-factor-authentication"
    }}>{`Two-factor authentication`}</h4>
    <p>{`Plaid allows you to enable two-factor authentication for your dashboard account via either text message or app-based authentication. After you enable two-factor authentication, you'll be prompted to enter an authentication code each time you sign in. When you enable two-factor authentication, Plaid will show you a backup recovery code. Be sure to write down the recovery code and store it in a safe place, since it will only be displayed once.`}</p>
    <p>{`To check whether your team members have enabled two-factor authentication, you can visit the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/settings/team/members"
      }}>{`Team Members page`}</a>{`, where the 2FA column shows "On" or "Off" for each team member.`}</p>
    <h4 {...{
      "id": "sso-login"
    }}>{`SSO login`}</h4>
    <p>{`Plaid offers SSO (single sign-on) login to the Plaid Dashboard for all customers, except those on Pay-as-you-go plans. We support all major identity providers, including Okta, Google Workspace, OneLogin, and over 30 others. You can enable your account for SSO via the Dashboard, under `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/settings/team/sso"
      }}>{`Settings > SSO`}</a>{`. There is no additional charge for SSO enablement.`}</p>
    <p>{`SCIM support is available to customers on Premium Support packages. To learn more, contact your account manager.`}</p>
    <h4 {...{
      "id": "rotating-keys"
    }}>{`Rotating keys`}</h4>
    <p>{`If your `}<inlineCode parentName="p">{`secret`}</inlineCode>{` is ever compromised, you should rotate it from the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/developers/keys"
      }}>{`Keys`}</a>{` section of the Dashboard. Clicking the `}<strong parentName="p">{`Rotate`}</strong>{` button will generate a new secret, which you can then copy and test. The old secret will still remain active until you delete it by clicking the `}<strong parentName="p">{`Delete`}</strong>{` button.`}</p>
    <h4 {...{
      "id": "managing-notification-settings"
    }}>{`Managing notification settings`}</h4>
    <p>{`To control which emails you receive from Plaid, you can update your `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/settings/team/notification-preferences"
      }}>{`notification settings`}</a>{` in the Dashboard.`}</p>
    <h4 {...{
      "id": "deleting-accounts"
    }}>{`Deleting accounts`}</h4>
    <p>{`To leave or delete a team, see `}<a parentName="p" {...{
        "href": "/docs/account/teams/#leaving-or-deleting-a-team"
      }}>{`Leaving or deleting a team`}</a>{`. `}</p>
    <p>{`To delete your Plaid Dashboard login itself, `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/support/new/admin/account-administration/delete-account"
      }}>{`contact support`}</a>{`. Note that deleting your login is irreversible.`}</p>
    <blockquote>
      <p parentName="blockquote">{`A Plaid Dashboard account is different from a Plaid account at my.plaid.com. To manage the financial information you're sharing via Plaid, visit `}<a parentName="p" {...{
          "href": "https://my.plaid.com/"
        }}>{`my.plaid.com`}</a>{`.`}</p>
    </blockquote>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "password-resets",
        level: 4,
        title: "Password resets",
      },
{
        id: "two-factor-authentication",
        level: 4,
        title: "Two-factor authentication",
      },
{
        id: "sso-login",
        level: 4,
        title: "SSO login",
      },
{
        id: "rotating-keys",
        level: 4,
        title: "Rotating keys",
      },
{
        id: "managing-notification-settings",
        level: 4,
        title: "Managing notification settings",
      },
{
        id: "deleting-accounts",
        level: 4,
        title: "Deleting accounts",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
